export const environment = {
    production: true,
    hmr       : false,
    api_url: 'https://staging.cct-ws.neopolis-dev.com',
    recaptchaSiteKey: '6Ld7MfgqAAAAAGY-rDesFJcuzRE0YbZegSD2aXZD',
    SENTRY_AUTH_TOKEN: '502331f57af97f287f679d887b69145fab397241a0700ef7fc3613f8d5ffbe69',
    build: '05-11-2026-09-00-13',
    version: require('../../package.json').version,
    NATIONALITY_TUNISIAN_ID :420,
    googleMapsApiKey: 'AIzaSyCAx6dN13VpYcAF4xiEWIZ9xKKz3e0j_DE',
    ADMIN_ROLE_ID: '2',
    sentryDsn: 'https://71efea0dd2be4a980006f1a006e74040@sentry.neopolis-dev.com/14',
    sentryEnvironment: 'production',
};
